<template>
  <div :id="$attrs['id']" :class="[[$attrs['class'], gridClasses], {'hm-reservation-color-picker--disabled': disabledCombined}]" class="hm-reservation-color-picker">
    <div class="hm-reservation-color-picker__options">
      <div :class="{'active': internalValue === 'category1' }" :title="isNil(hotelSettings.details.colorCategoryLabels) || isNil(hotelSettings.details.colorCategoryLabels.category1) ? '' : hotelSettings.details.colorCategoryLabels.category1[$shortLocale]" class="hm-reservation-color-picker__option" @click="toggleState('category1')">
        <span class="hm-reservation-color-picker__option__color hm-reservation-color-picker__option__color--category-1"></span>
      </div>
      <div :class="{'active': internalValue === 'category2' }" :title="isNil(hotelSettings.details.colorCategoryLabels) || isNil(hotelSettings.details.colorCategoryLabels.category2) ? '' : hotelSettings.details.colorCategoryLabels.category2[$shortLocale]" class="hm-reservation-color-picker__option" @click="toggleState('category2')">
        <span class="hm-reservation-color-picker__option__color hm-reservation-color-picker__option__color--category-2"></span>
      </div>
      <div :class="{'active': internalValue === 'category3' }" :title="isNil(hotelSettings.details.colorCategoryLabels) || isNil(hotelSettings.details.colorCategoryLabels.category3) ? '' : hotelSettings.details.colorCategoryLabels.category3[$shortLocale]" class="hm-reservation-color-picker__option" @click="toggleState('category3')">
        <span class="hm-reservation-color-picker__option__color hm-reservation-color-picker__option__color--category-3"></span>
      </div>
      <div :class="{'active': internalValue === 'category4' }" :title="isNil(hotelSettings.details.colorCategoryLabels) || isNil(hotelSettings.details.colorCategoryLabels.category4) ? '' : hotelSettings.details.colorCategoryLabels.category4[$shortLocale]" class="hm-reservation-color-picker__option" @click="toggleState('category4')">
        <span class="hm-reservation-color-picker__option__color hm-reservation-color-picker__option__color--category-4"></span>
      </div>
      <div :class="{'active': internalValue === 'category5' }" :title="isNil(hotelSettings.details.colorCategoryLabels) || isNil(hotelSettings.details.colorCategoryLabels.category5) ? '' : hotelSettings.details.colorCategoryLabels.category5[$shortLocale]" class="hm-reservation-color-picker__option" @click="toggleState('category5')">
        <span class="hm-reservation-color-picker__option__color hm-reservation-color-picker__option__color--category-5"></span>
      </div>
      <div :class="{'active': internalValue === 'category6' }" :title="isNil(hotelSettings.details.colorCategoryLabels) || isNil(hotelSettings.details.colorCategoryLabels.category6) ? '' : hotelSettings.details.colorCategoryLabels.category6[$shortLocale]" class="hm-reservation-color-picker__option" @click="toggleState('category6')">
        <span class="hm-reservation-color-picker__option__color hm-reservation-color-picker__option__color--category-6"></span>
      </div>
      <div :class="{'active': internalValue === 'category7' }" :title="isNil(hotelSettings.details.colorCategoryLabels) || isNil(hotelSettings.details.colorCategoryLabels.category7) ? '' : hotelSettings.details.colorCategoryLabels.category7[$shortLocale]" class="hm-reservation-color-picker__option" @click="toggleState('category7')">
        <span class="hm-reservation-color-picker__option__color hm-reservation-color-picker__option__color--category-7"></span>
      </div>
    </div>
    <div class="hm-reservation-color-picker__help" v-html="help" />
    <div class="hm-reservation-color-picker__label" v-html="label" />
  </div>
</template>

<script>

import HmInputMixin from '@/mixins/HmInputMixin';
import GridMixin from '@/mixins/GridMixin';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';

export default {
  name: 'HmReservationColorPicker',

  mixins: [HmInputMixin, GridMixin, HotelmeisterMixin],

  methods: {
    toggleState: function (newValue) {
      if (!this.disabledCombined) {
        this.internalValue = this.internalValue === newValue ? null : newValue;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~styles/import";
.hm-reservation-color-picker {
  position: relative;
  padding-top: 0.6rem;
  &--disabled {
    pointer-events: none;

    .hm-reservation-color-picker {
      &__option {
        background-color: $lightgray;
        &__color {
          background-color: $middlegray !important;
          &:before {
            opacity: 0!important;
          }
        }
      }
    }
  }
  &__options {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    border: 0.1rem solid $middlegray;
    border-radius: 0.3rem;
    align-items: center;
    justify-items: center;
  }
  &__option {
    border-right: 0.1rem solid $middlegray;
    width: 100%;
    display: grid;
    align-items: center;
    justify-items: center;
    padding: 0.8rem 0;
    &:hover {
      .hm-reservation-color-picker__option__color {
        &:before {
          opacity: 1;
        }
      }
    }
    &__color {
      width: 1.4rem;
      height: 1.4rem;
      border-radius: 50%;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        left: -0.3rem;
        top: -0.3rem;
        display: block;
        opacity: 0;
        transition: opacity 0.2s ease;
      }
      &--category-1 {
        background-color: rgba($category1, 0.6);
        &:before {
          background-color: rgba($category1, 0.4);
        }
      }
      &--category-2 {
        background-color: rgba($category2, 0.6);
        &:before {
          background-color: rgba($category2, 0.4);
        }
      }
      &--category-3 {
        background-color: rgba($category3, 0.6);
        &:before {
          background-color: rgba($category3, 0.4);
        }
      }
      &--category-4 {
        background-color: rgba($category4, 0.6);
        &:before {
          background-color: rgba($category4, 0.4);
        }
      }
      &--category-5 {
        background-color: rgba($category5, 0.6);
        &:before {
          background-color: rgba($category5, 0.4);
        }
      }
      &--category-6 {
        background-color: rgba($category6, 0.6);
        &:before {
          background-color: rgba($category6, 0.4);
        }
      }
      &--category-7 {
        background-color: rgba($category7, 0.6);
        &:before {
          background-color: rgba($category7, 0.4);
        }
      }
    }
    &:last-of-type {
      border-right: none;
    }

    &.active {
      .hm-reservation-color-picker__option__color {
        &:before {
          opacity: 1;
        }
      }
    }
    &:hover {
      cursor: pointer;
    }
  }
  &__help {
    color: $gray;
    font-size: 1.1rem;
    padding-left: 1rem;
    height: 1.4rem;
    line-height: 1.4rem;
    margin-bottom: 0.3rem;
    margin-top: 0.3rem;
  }
  &__label {
    position: absolute;
    top: 0;
    left: 0.6rem;
    font-size: 1.1rem;
    color: $gray;
    transition: all 0.2s ease;
    z-index: 2;
    pointer-events: none;
    background-color: $white;
    padding: 0 0.4rem;
    border-radius: 0.3rem;
    will-change: top, font-size;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmReservationColorPicker.vue